import React from "react";
import {
  Document,
  Page,
  Text,
  View,
  Image,
  StyleSheet,
} from "@react-pdf/renderer";
import { SubjectDetail } from "../gradeReport";

interface Grade {
  grade: string;
  description: string;
  range: string;
}

interface PDFTemplateProps {
  student: any;
  school: any;
  scores: SubjectDetail[];
  grading: any[];
  academic_calendar: any[];
}

const getTodayDate = () => {
  const date = new Date();
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
};

const getRandomRemark = () => {
  const remarks = [
    "Great progress this term, keep it up!",
    "Needs improvement in some areas, but overall good.",
    "Shows great promise, but can work harder.",
    "A solid term, though there is room for growth.",
    "Excellent effort, keep up the good work!",
  ];
  const randomIndex = Math.floor(Math.random() * remarks.length);
  return remarks[randomIndex];
};

const PDFTEMPLATE = ({
  student,
  school,
  scores,
  grading,
  academic_calendar,
}: PDFTemplateProps) => {

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        {/* Header Section */}
        <View style={styles.header}>
          <Image style={styles.image} src={require("./YMA.png")} />
          <Text style={styles.logo}>
            {school?.school_name || "EliteScholar"}
          </Text>
        </View>
        <View style={styles.schoolInfo}>
          <Text style={{ fontWeight: "bold", height: "15px" }}>
            Address:{" "}
            {school?.address}
          </Text>
          <Text
            style={{
              backgroundColor: "blue",
              padding: "5px",
              borderRadius: "15px",
              width: "40%",
              marginLeft: "auto",
              marginRight: "auto",
              color: "white",
            }}
          >
            {scores[0]?.section || "PRIMARY"}{" "} SECTION
          </Text>
        </View>
        <View style={styles.contactInfo}>
          <Text style={{ marginTop: "5px" }}>
            {`GSM: ${school?.primary_contact_number}, ${school?.secondary_contact_number} | Email: ${school?.email_address}`}
          </Text>
        </View>

        {/* Student Information Section */}
        <View style={styles.thickBorder}>
          <View style={styles.inputField}>
            <Text>Name: {student.student_name}</Text>
            <Text>Admission No: {student.admission_no}</Text>
          </View>
          <View style={styles.inputField}>
            <Text>Class: {student.class_name}</Text>
            <Text>Term: {student.term}</Text>
            <Text>Session: {student.academic_year}</Text>
          </View>
        </View>

        {/* Academic and Moral Record Section */}
        <View style={styles.section}>
          <View style={[styles.tableHeader, { padding: 0 }]}>
            <View style={{ width: "70%", textAlign: "center" }}>
              <Text>Academic Record</Text>
            </View>
            <View
              style={{
                width: "30%",
                textAlign: "center",
                borderLeft: "0.5px solid blue",
                margin: 0,
              }}
            >
              <Text>Moral Values</Text>
            </View>
          </View>
          <View style={styles.boxedTable}>
            {/* Academic Record */}
            <View style={{ width: "70%", borderRight: "0.5px solid blue" }}>
              <View style={styles.tableRowHeader}>
                <Text
                  style={{
                    ...styles.tableCellLeft,
                    width: "50%",
                    color: "white",
                  }}
                >
                  Subjects
                </Text>
                <Text
                  style={{ ...styles.moralHeaderTableCell, width: "10%", color: "white" }}
                >
                  Test
                </Text>
                <Text
                  style={{ ...styles.moralHeaderTableCell, width: "10%", color: "white" }}
                >
                  ASS
                </Text>
                <Text
                  style={{ ...styles.moralHeaderTableCell, width: "10%", color: "white" }}
                >
                  Exam
                </Text>
                <Text
                  style={{ ...styles.moralHeaderTableCell, width: "10%", color: "white" }}
                >
                  Total
                </Text>
                <Text
                  style={{ ...styles.moralHeaderTableCell, width: "10%", color: "white" }}
                >
                  Grade
                </Text>
              </View>
              {scores
                .filter((x) => x.type === "Academic")
                .map((subject: any, idx: number) => {
                  const total =
                    (parseFloat(subject.caScore || "0") || 0) +
                    (parseFloat(subject.examScore || "0") || 0) +
                    (parseFloat(subject.assignmentScore || "0") || 0);

                  return (
                    <View style={styles.tableRow} key={idx}>
                      <Text
                        style={[
                          styles.tableCellLeft,
                          { width: "50%", fontSize: "8px" },
                        ]}
                      >
                        {subject.subject}
                      </Text>
                      <Text
                        style={[
                          styles.tableCell,
                          { width: "10%", fontSize: "8px" },
                        ]}
                      >
                        {subject.caScore || "0"}
                      </Text>
                      <Text
                        style={[
                          styles.tableCell,
                          { width: "10%", fontSize: "8px" },
                        ]}
                      >
                        {subject.assignmentScore || "0"}
                      </Text>
                      <Text
                        style={[
                          styles.tableCell,
                          { width: "10%", fontSize: "8px" },
                        ]}
                      >
                        {subject.examScore || "0"}
                      </Text>
                      <Text
                        style={[
                          styles.tableCell,
                          { width: "10%", fontSize: "8px" },
                        ]}
                      >
                        {total}
                      </Text>
                      <Text
                        style={[
                          styles.tableCell,
                          { width: "10%", fontSize: "8px" },
                        ]}
                      >
                        {subject.grade || ""}
                      </Text>
                    </View>
                  );
                })}
            </View>

            {/* Moral Values Section */}
            <View style={{ width: "30%" }}>
              {/* Skills Section */}
              <View style={styles.tableRowHeader}>
                <Text
                  style={{
                    ...styles.moralHeaderTableCell,
                    width: "60%",
                    color: "white",
                  }}
                >
                  Skills
                </Text>
                <Text
                  style={{
                    ...styles.moralHeaderTableCellLeft,
                    width: "40%",
                    color: "white",
                  }}
                >
                  Grading
                </Text>
              </View>
              {scores?.filter((item) => item.type !== 'Academic' && item?.section === 'Skills')?.map((skill: any, idx: number) => (
                <View style={styles.tableRow} key={idx}>
                  <Text
                    style={{
                      ...styles.moralTableCell,
                      width: "60%",
                      fontSize: "8px",
                    }}
                  >
                    {skill.subject}
                  </Text>
                  <Text
                    style={{
                      ...styles.tableCell,
                      width: "40%",
                      fontSize: "8px",
                    }}
                  >
                    {skill.grade}
                  </Text>
                </View>
              ))}

              {/* Affective Behavior Section */}
              <View style={styles.tableRowHeader}>
                <Text
                  style={{
                    ...styles.moralHeaderTableCell,
                    width: "60%",
                    color: "white",
                  }}
                >
                  Affective Behavior
                </Text>
                <Text
                  style={{
                    ...styles.moralHeaderTableCellLeft,
                    width: "40%",
                    color: "white",
                  }}
                >
                  Grading
                </Text>
              </View>
              {scores?.filter((item) => item.type !== 'Academic' && item?.section !== 'Skills')?.map((behavior: any, idx: number) => (
                <View style={styles.tableRow} key={idx}>
                  <Text
                    style={{
                      ...styles.moralTableCell,
                      width: "60%",
                      fontSize: "8px",
                    }}
                  >
                    {behavior.subject}
                  </Text>
                  <Text
                    style={{
                      ...styles.tableCell,
                      width: "40%",
                      fontSize: "8px",
                    }}
                  >
                    {behavior.grade}
                  </Text>
                </View>
              ))}
            </View>
          </View>
        </View>

        {/* Remarks and Signatures */}
        
        <View style={styles.section}>
          <View style={{border: "1px solid blue", padding: "8px"}}>
          <Text>Class Teacher's Remark: {scores[0]?.remark}</Text>
          <Text style={{ marginTop: "10px", marginBottom: "10px" }}>
            Principal's Remark: {getRandomRemark()}
          </Text>
          </View>

          <View style={styles.thickBorder1}>
          <View style={styles.inputField}>
            <Text>Student's Score:___________</Text>
            <Text>Out Of:___________ </Text>
            <Text>Percentage:___________ </Text>
          </View>
          <View style={styles.inputField}>
            <Text>Class Attendance of:___________ </Text>
            <Text>Out of:___________ </Text>
          </View>
        </View>

          {/* <View style={styles.signatureSection}>
            <Text style={{ marginTop: "1px", marginBottom: "1px" }}>
              Next term begins: {"____________________"}
            </Text>
            <Text style={{ marginTop: "5px", marginBottom: "5px" }}>
              Next Term Fees: {"____________________"}
            </Text>
          </View> */}
          <View style={styles.thickBorder1}>
          <View style={styles.inputField}>
            <Text>Next Term Begins:{academic_calendar}</Text>
            <Text>Next Term Fees:__________________ </Text>
          </View>
          <View style={styles.inputField}>
            <Text>Principal's Sign:___________ </Text>
            <Text>Date:___________ </Text>
          </View>
        </View>
          {/* <View style={styles.signatureSection}>
            <Text style={{ marginTop: "5px", marginBottom: "5px" }}>
              Principal's Sign: ____________________
            </Text>
            <Text style={{ marginTop: "5px", marginBottom: "5px" }}>
              Electronic Signature: ____________________
            </Text>
            <Text style={{ marginTop: "5px", marginBottom: "5px" }}>
              Date: {getTodayDate()}
            </Text>
          </View> */}
        </View>
      </Page>
    </Document>
  );
};

const styles = StyleSheet.create({
  page: {
    padding: 20,
    fontSize: 10,
    color: "#003366",
  },
  header: {
    textAlign: "center",
    position: "relative",
    marginBottom: 10,
    paddingBottom: 10,
  },
  image: {
    width: "65px",
    height: "65px",
    position: "absolute",
  },
  logo: {
    fontSize: 33,
    marginLeft: "45px",
    color: "blue",
    fontWeight: "bold",
  },
  schoolInfo: {
    textAlign: "center",
    marginBottom: 5,
  },
  contactInfo: {
    textAlign: "center",
    marginBottom: 10,
  },
  thickBorder: {
    border: "1px solid blue",
    borderBottom: "1px solid blue",
    padding: 5,
    marginBottom: 5,
  },
  thickBorder1: {
    border: "1px solid blue",
    borderBottom: "1px solid blue",
    padding: 5,
    marginBottom: 1,
  },
  inputField: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    marginVertical: 5,
  },
  section: {
    marginTop: 5,
    padding: 5,
  },
  tableHeader: {
    display: "flex",
    flexDirection: "row",
    fontWeight: "bold",
    borderBottom: "none",
    padding: 5,
    border: "0.5px solid blue",
  },
  boxedTable: {
    display: "flex",
    flexDirection: "row",
    border: "0.5px solid blue",
  },
  tableRowHeader: {
    display: "flex",
    flexDirection: "row",
    backgroundColor: "blue",
    color: "white",
  },
  tableRow: {
    display: "flex",
    flexDirection: "row",
    borderBottom: "1px solid blue",
  },
  tableCell: {
    width: "12.5%",
    textAlign: "center",
    padding: 5,
    borderRight: "none",
    borderLeft: "1px solid blue",
    borderBottom: "none",
  },
  tableCellLeft: {
    width: "30%",
    textAlign: "left",
    padding: 5,
    borderBottom: "none",
    borderRight: "0.5px solid white",
    textTransform: "uppercase",
    fontSize: "7px",
    fontWeight: "demibold"
  },
  moralTableCell: {
    width: "50%",
    textAlign: "left",
    padding: 5,
    borderBottom: "none",
  },

  // borderRight: "0.5px solid white",

  moralHeaderTableCell: {
    width: "50%",
    textAlign: "left",
    padding: 5,
    borderBottom: "none",
    borderRight: "0.5px solid white",
    textTransform: "uppercase",
    fontSize: "7px",
    fontWeight: "demibold"
  },
  moralHeaderTableCellLeft: {
    width: "12.5%",
    textAlign: "center",
    padding: 5,
    borderRight: "none",
    borderLeft: "1px solid white",
    borderBottom: "none",
    textTransform: "uppercase",
    fontWeight: "demibold",
    fontSize: "7px",

  },

  signatureSection: {
    flexDirection: "column",
    justifyContent: "space-evenly",
    marginTop: 10,
    padding: 5,
    border: "0.5px solid blue",
  },
});

export default PDFTEMPLATE;
